var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm._uid,
      staticClass: "toggle",
      on: {
        click: function($event) {
          _vm.localValue = !_vm.localValue
          _vm.update()
        }
      }
    },
    [
      _c("div", {
        staticClass: "toggle-mark",
        class: { active: _vm.localValue },
        style: { left: _vm.localValue ? "17px" : "0" }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "toggle-lane",
        class: { active: _vm.localValue }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }